import Swal from "sweetalert2";

export function swalConfirm($msg, $title, $cText, $cancelText) {
  try {
    let result = Swal.fire({
      title: $title || "Are you sure?",
      text: $msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: $cancelText || "Cancel",
      confirmButtonText: $cText || "Yes, delete it!",
      allowOutsideClick: false,
    });
    return result;
  } catch (e) {
    // Fail!
    console.error(e);
    return false;
  }
}

export function swalConfirmWithRemark(
  $msg,
  $title,
  $cText,
  $inputLabel,
  $inputPlaceholder,
  $isRemarkRequired = false
) {
  try {
    let result = Swal.fire({
      title: $title || "Are you sure?",
      text: $msg,
      input: "textarea",
      inputAttributes: {
        autocapitalize: "off",
      },
      inputLabel: $inputLabel || "Please provide a remark (optional)",
      inputPlaceholder: $inputPlaceholder || "Type your remark here",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: $cText || "Yes, delete it!",
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: async (login) => {
        try {
          if($isRemarkRequired && !document.getElementById('swal2-textarea')?.value) {
            Swal.showValidationMessage(`Required`)
          } else {
            return login;
          }
        } catch (error) {
          Swal.showValidationMessage(`
            Request failed: ${error}
          `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return result;
  } catch (e) {
    // Fail!
    console.error(e);
    return false;
  }
}

//Error Message
export function swalError($msg, $title = "Error") {
  try {
    let result = Swal.fire({
      icon: "error",
      title: $title,
      text: $msg,
      allowOutsideClick: false,
    });
    return result;
  } catch (e) {
    // Fail!
    console.error(e);
    return false;
  }
}

//Error Message
export function swalWarning($msg, $title = "Warning!") {
  try {
    let result = Swal.fire({
      icon: "warning",
      title: $title,
      text: $msg,
      allowOutsideClick: false,
    });
    return result;
  } catch (e) {
    // Fail!
    return false;
  }
}

//Success Message
export function swalSuccess(
  $text = "Your work has been saved!",
  $title = "Success!",
  $html = false
) {
  try {
    let result = "";
    if ($html !== false) {
      result = Swal.fire({
        icon: "success",
        title: $title,
        html: $html,
        showConfirmButton: false,
        allowOutsideClick: false,
        timer: 2500,
      });
    } else {
      result = Swal.fire({
        icon: "success",
        title: $title,
        text: $text,
        showConfirmButton: false,
        allowOutsideClick: false,
        timer: 2500,
      });
    }
    return result;
  } catch (e) {
    // Fail!
    console.error(e);
    return false;
  }
}
export function showErrorTable(errors) {
  const tableHTML = `
    <table style="width:100%; border-collapse: collapse;">
      <thead>
        <tr>
          <th style="border:1px solid #ccc; padding:6px;">PIN</th>
          <th style="border:1px solid #ccc; padding:6px;">Name</th>
          <th style="border:1px solid #ccc; padding:6px;">Required Off</th>
          <th style="border:1px solid #ccc; padding:6px;">Assigned Off</th>
        </tr>
      </thead>
      <tbody>
        ${errors
          .map(
            (e) => `
          <tr>
            <td style="border:1px solid #ccc; padding:6px;">${e.pin}</td>
            <td style="border:1px solid #ccc; padding:6px;">${e.name}</td>
            <td style="border:1px solid #ccc; padding:6px; color:red; font-weight:bold;">
              ${e.required}
            </td>
            <td style="border:1px solid #ccc; padding:6px; color:red; font-weight:bold;">
              ${e.assigned}
            </td>
          </tr>
        `
          )
          .join("")}
      </tbody>
    </table>
  `;

  Swal.fire({
    title: "Validation Errors",
    html: tableHTML,
    width: "700px",
    icon: "error",
  });
}

export function swalPrintOptions(
  $msg = "Do you want to print with signature or without signature?",
  $title = "Print Options"
) {
  try {
    let result = Swal.fire({
      title: $title,
      text: $msg,
      icon: "question",
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "With Signature",
      denyButtonText: "Without Signature",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#1890ff",
      denyButtonColor: "#ffffff",
      cancelButtonColor: "#ff4d4f",
      customClass: {
        denyButton: "swal-deny-button-outline",
      },
      allowOutsideClick: false,
    });
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
}